import { render, staticRenderFns } from "./AccountDelete.vue?vue&type=template&id=42f4c23e&scoped=true&"
import script from "./AccountDelete.vue?vue&type=script&lang=js&"
export * from "./AccountDelete.vue?vue&type=script&lang=js&"
import style0 from "./AccountDelete.vue?vue&type=style&index=0&id=42f4c23e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f4c23e",
  null
  
)

export default component.exports